import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import _ from 'lodash';
import history from 'app/routes/history';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import {
  connectionTypeSchema,
  connectionTypeListSchema,
} from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import { loadingStart, loadingFinish } from 'app/ducks/loading/actions';
import { sagaActions } from 'app/ducks/connectionTypes/actions';
import { ConnectionTypesActionTypes as types } from 'app/ducks/connectionTypes/types';

function* createConnectionTypeSaga(action): any {
  yield put(sagaActions.createConnectionTypePending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connectionTypes.create(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, connectionTypeSchema);
    history.push(`/competitions/${action.payload.competition.id}`);
    yield put(sagaActions.createConnectionTypeSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createConnectionTypeFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* updateConnectionTypeSaga(action): any {
  yield put(sagaActions.updateConnectionTypePending(action.payload));
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connectionTypes.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, connectionTypeSchema);

    yield put(sagaActions.updateConnectionTypeSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateConnectionTypeFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getConnectionTypeSaga(action): any {
  yield put(sagaActions.getConnectionTypePending());

  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connectionTypes.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, connectionTypeSchema);
    yield put(sagaActions.getConnectionTypeSuccess(normalizedResponse));
    return normalizedResponse.entities.connectionTypes[
      normalizedResponse.result
    ];
  }
  yield put(
    handleError(
      error,
      sagaActions.getConnectionTypeFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    ),
  );
  return null;
}

function* getAllConnectionTypesSaga(action): any {
  yield put(
    sagaActions.getAllConnectionTypesPending(
      action.payload.compile ? action.payload.pagination : {},
    ),
  );
  yield put(loadingStart());
  const paginationObject = action.payload.compile
    ? compilePaginationObject(
      yield select((state) => state.connectionTypes.pagination),
    )
    : action.payload.pagination;
  const [error, response] = yield (yield TeammoApi(
    yield select(),
  )).connectionTypes.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(
      response,
      connectionTypeListSchema,
    );

    yield put(
      sagaActions.getAllConnectionTypesSuccess(
        normalizedResponse,
        response.meta,
      ),
    );
    yield put(loadingFinish());
  } else {
    yield put(
      error,
      sagaActions.getAllConnectionTypesFailed(
        _.isEmpty(error) ? {} : error.response.data.errors,
      ),
    );
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createConnectionTypeSagaWatcher(): any {
  yield takeLatest(
    types.CREATE_CONNECTION_TYPE_REQUESTED,
    createConnectionTypeSaga,
  );
}

function* updateConnectionTypeSagaWatcher(): any {
  yield takeLatest(
    types.UPDATE_CONNECTION_TYPE_REQUESTED,
    updateConnectionTypeSaga,
  );
}

function* getConnectionTypeSagaWatcher(): any {
  yield takeLatest(
    types.GET_CONNECTION_TYPE_REQUESTED,
    getConnectionTypeSaga,
  );
}

function* getAllConnectionTypesSagaWatcher(): any {
  yield takeLatest(
    types.GET_ALL_CONNECTION_TYPES_REQUESTED,
    getAllConnectionTypesSaga,
  );
}

export default function* root(): any {
  yield all([
    createConnectionTypeSagaWatcher(),
    updateConnectionTypeSagaWatcher(),
    getConnectionTypeSagaWatcher(),
    getAllConnectionTypesSagaWatcher(),
  ]);
}
